export const en = {
  translation: {
    "vehicle_in_all_places": "Veículos em qualquer lugar do Brasil",
    "ts_vehicle_automatic": "Automatic",
  }
}